var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 10.5V7.5C19.5 3.3 16.2 0 12 0C7.8 0 4.5 3.3 4.5 7.5V10.5C1.95 10.5 0 12.45 0 15V25.5C0 28.05 1.95 30 4.5 30H19.5C22.05 30 24 28.05 24 25.5V15C24 12.45 22.05 10.5 19.5 10.5ZM7.5 7.5C7.5 4.95 9.45 3 12 3C14.55 3 16.5 4.95 16.5 7.5V10.5H7.5V7.5ZM13.65 20.25L13.5 20.4V22.5C13.5 23.4 12.9 24 12 24C11.1 24 10.5 23.4 10.5 22.5V20.4C9.6 19.5 9.45 18.15 10.35 17.25C11.25 16.35 12.6 16.2 13.5 17.1C14.4 17.85 14.55 19.35 13.65 20.25Z",
    fill: "#D3FF9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.344c2238ad6a4bac5124a99bb26cc3cd.svg";
export { ForwardRef as ReactComponent };